import React from 'react';
import ReactSlider from 'react-slick';
import winImg from '../images/win.png';
import lostImg from '../images/lost.png';
import {useLang} from '../context/LanguageContext';
// Example background image
import lastPredictionsBg from '../images/bg_last_pred.png'; // or .png, adjust path as needed

const LastPredictionsSlider = ({ data }) => {
  // data = { wins: [...], lost: [...] }
  const combinedPredictions = [...data.wins, ...data.lost];
  const { t, getBetTranslation } = useLang()

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
    pauseOnHover: false,
    pauseOnFocus: false,
    pauseOnDotsHover: false
  };

  return (
    <div className="mx-auto my-4 w-full max-w-[95vw] md:max-w-[800px] overflow-hidden">
      <h2 className="text-xl font-bold text-center mb-4 text-white">
        {t('txt.lastPredictions')}
      </h2>

      <ReactSlider {...settings}>
        {combinedPredictions.map((item) => {
          const translatedMarketName = getBetTranslation(item.marketName);
          const translatedMarket = getBetTranslation(item.market);

          return (
          <div key={item.id} className="p-2">
            {/* Slide container with background image */}
            <div
              className="
                rounded shadow p-4 flex flex-col 
                bg-cover bg-center
                text-white
                min-h-[200px]
              "
              style={{
                backgroundImage: `url(${lastPredictionsBg})`
              }}
            >
              {/* Top row: flag + country */}
              <div className="flex items-center mb-2 p-2">
                {item.flag && (
                  <img
                    src={item.flag}
                    alt="Flag"
                    className="w-6 h-6 mr-2"
                  />
                )}
                <span className="text-sm font-medium">{item.countryName}</span>
              </div>

              {/* Teams row */}
              <div className="text-sm font-semibold mb-2">
                {item.team1} vs {item.team2}
              </div>

              {/* Date/time row */}
              <div className="flex items-center text-sm mb-2">
                <span className="mr-4">{item.day}</span>
                <span>{item.hour}</span>
              </div>

              {/* Market & Odd row */}
              <div className="text-sm mb-2">
                <span className="font-medium">
                  {translatedMarketName} ({translatedMarket})
                </span>
                {' - '}
                <span className="font-bold text-green-400">{item.odd}</span>
              </div>

              {/* Status image */}
              <div className="flex items-center justify-end">
                {item.status === 'win' ? (
                  <img src={winImg} alt="Win" className="w-8 h-8" />
                ) : item.status === 'lost' ? (
                  <img src={lostImg} alt="Lost" className="w-8 h-8" />
                ) : null}
              </div>
            </div>
          </div>
        )})}
      </ReactSlider>
    </div>
  );
};

export default LastPredictionsSlider;
